import * as React from 'react';
import LayerListContainer from '../../LayerList/_containers/LayerListContainer';
import PreviewFabricContainer from '../../Tools/_containers/PreviewFabricContainer';
import DocumentActionButtonsContainer from '../../Tools/_containers/DocumentActionButtonsContainer';
import PatternActionButtonsContainer from '../../Tools/_containers/PatternActionButtonsContainer';
import ModulesButtonsContainer from '../../Tools/_containers/ModulesButtonsContainer';
import ModuleCreatorContainer from '../../ModuleCreator/_containers/ModuleCreatorContainer';
import { Trans } from "react-i18next";
import SubtleButton from '@af-common/Common/_components/SubtleButton';
import { Button, ButtonBase, Dialog, DialogContent, DialogTitle } from '@mui/material';
import { Close } from '@mui/icons-material';

const T = ({children, ...otherProps}:any) => <Trans ns="create" {...otherProps}>{children}</Trans>

export type Props = {
	resizeViewer?: Function
	setIsFullWidth?: Function
	viewerHeight?: number
	windowWidth?: number
	previewFabricEnabled?: boolean
	moduleCreatorOpened?: boolean
	layerListOpened?: boolean
	onLayerListVisibility?: Function
	onModuleCreatorClose?: Function
};

export type State = {
	blurryPreviewDialogOpen: boolean
};

export default class Sidebar extends React.Component<Props, State> {
	state = {
		blurryPreviewDialogOpen: false
	}

	private getWidth = () => this.props.moduleCreatorOpened ? 312 : this.props.layerListOpened ? 362 : 112;

	private closeOverlays(e:React.MouseEvent) {
		const target = e.target as HTMLElement
		const parentHasClassModules = target.closest('.action-buttons__modules');
		const parentHasClassLayers = target.closest('.layers-btn');
		const parentHasClassLayerList = target.closest('.layer-list');
		const parentHasClassPrompt = target.closest('.af-prompt');

		// Close layer list overlay if modules are opened
		if (parentHasClassModules) {
			this.props.onLayerListVisibility(false)
		}
		// Close modules overlay if layer list is opened
		else if (parentHasClassLayers) {
			this.props.onModuleCreatorClose()
		}
		// Close both if anything else is clicked
		else {
			this.props.onModuleCreatorClose()
			// Don't close if layer list or a prompt is the target
			if (!parentHasClassLayerList && !parentHasClassPrompt && !target.closest('.MuiBackdrop-root')) this.props.onLayerListVisibility(false)
		}
	}

	render = () => <div onClick={this.closeOverlays.bind(this)} >
		<LayerListContainer />
		<div className="create-sidebar" >
			<ModulesButtonsContainer withBottomBorder={true} />
			<div className="doc-action-btns-visibility on-sidebar" >
				<DocumentActionButtonsContainer flexDirection="column" withBottomBorder={true} />
			</div>
			<PatternActionButtonsContainer />
		</div>
		<ModuleCreatorContainer />
		{this.props.previewFabricEnabled ?
			<PreviewFabricContainer />
		:
			<>

				<SubtleButton id="why-my-preview-sook" style={{right: this.getWidth() + 'px'}} className="help-link" onClick={() => this.setState({blurryPreviewDialogOpen: true})}>
					<img src="static/img/lab/blurry.svg" /><T>Preview is blurry?</T>
				</SubtleButton>
				<Dialog role="dialog" className="intro-dialog previewblurry" open={this.state.blurryPreviewDialogOpen} onClose={() => this.setState({blurryPreviewDialogOpen:false})}>
					<DialogTitle><T>Why is my preview blurry ?</T></DialogTitle>
					<DialogContent>
						<p className="description"><T>The Design Lab displays a low-resolution version of the uploaded image to make the design process more efficient. It may appear blurry on high-quality monitors. When you submit an order, rest assured we will receive the full-resolution image you uploaded for printing.</T></p>
						<Button onClick={() => this.setState({blurryPreviewDialogOpen:false})}><T>OK !</T></Button>
					</DialogContent>
				</Dialog>

				<SubtleButton style={{right: this.getWidth() + 'px'}} className="help-link" link="https://blog.artfabrics.com/design-lab-tutorials/" icon="help_outline" iconHover="help">
					<T>Need help?</T>
				</SubtleButton>
			</>
		}
	</div>
}